import styled from "styled-components";
import { Element } from "react-scroll";

import Player from "../../components/Player";
import tracks from "../../tracks";

const Music = () => {
  return (
    <Element name={"music"}>
      <Wrapper>
        <Player tracks={tracks} />
      </Wrapper>
    </Element>
  );
};

const Wrapper = styled.section`
  background: var(--second-color);
  padding: 20px;
  min-height: fit-content;
  height: clamp(640px, 92vh, 92vh);
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1000px) {
  }
`;
export default Music;
